import { isNull } from 'lodash';
import { IDS } from '../../pnp-doc.constants';
import * as PnpDocActions from '../../pnp-doc.actions'
import * as PnpDocsActions from '../../../pnp-docs.actions'
import watch from 'redux-watch';
import get from "lodash/get";
import { PNP_SELECT_CASCADE_STANDARD, PNP_SELECT_CASCADE_STANDARD_RESET } from '../../../pnp-docs.actions.types';



/**
 * @const {object}
 * @memberOf module:policies 
 */
export const pnpDocumentAccreditationDetails = {



    /* @ngInject */
    controller: function ($ngRedux, $state, $scope, $rootScope, Notifier) {
        const unsubscribe = $ngRedux.connect(({ policies }) => ({
            pnpDocument: policies.pnpDocument,
            assignedSections: policies.pnpDocSectionsGrid.items
        }), {
            ...PnpDocActions,
            ...PnpDocsActions
        })(this);

        let isInitialized = false; // Flag to track initialization of `initStandardsInputSelects`
        let previousSchemeCode = null; // Track the previous value of `schemeCode`
        let isSchemeCodeChanged = false; // Flag to track if schemeCode has chang

        $scope.$watch(
            () => this.pnpDocument.documentAccreditationSection,
            (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    this.handleSectionChange(newValue);
                }
            },
            true // Enable deep watch
        );

        /**
        * Method to handle section changes
        */
        this.handleSectionChange = (newSection) => {
            this.initStandardsInputSelects({});
        };




        const watchAccrediationSectionChange = watch($ngRedux.getState, 'policies.pnpDocument.selectdocumentAccreditationSchemes');
        const unsubscribeAccrediationSectionChange = $ngRedux.subscribe(watchAccrediationSectionChange(() => {
            this.getAccreditationSection(this.pnpDocument.selectdocumentAccreditationSchemes)
            this.schemeCode = this.pnpDocument.selectdocumentAccreditationSchemes
            if (this.schemeCode !== previousSchemeCode) {
                previousSchemeCode = this.schemeCode;
                isSchemeCodeChanged = true;
            }
        }));
        const selectChangePnpDocument = watch($ngRedux.getState, 'policies.pnpDocument.documentAccreditationSection');
        const unsubscribeselectChangePnpDocument = $ngRedux.subscribe(selectChangePnpDocument(() => {
            this.sectionsTree = this.pnpDocument.documentAccreditationSection;
            if (isSchemeCodeChanged && this.sectionsTree && !isInitialized) {
                this.initStandardsInputSelects({})
                isInitialized = true;
                isSchemeCodeChanged = false;
                unsubscribeselectChangePnpDocument();
            }
        }));

        /**
         * @function $onInit
         */
        this.$onInit = () => {

            this.title = 'Add Accreditation Document'
            this.identifier = 'pnpDocument'
            this.stateIdentifier = 'pnpDocument';
            this.getAccreditationSchemes();
            if (this.pnpDocument.id) {
                this.identifier = IDS.app_policies_documents_manage;
                this.state = IDS.app_policies_documents_accreditation_add_details;
            }
            if (!this.pnpDocument.documentAccreditationSection) {
                $ngRedux.dispatch({
                    type: 'GRID_FETCH',
                    id: 'pnpDocSectionsGrid',
                    items: [],
                });
            }
        }


        this.initStandardsInputSelects = ({ deselectAll }) => {
            this.sectionsTree = this.pnpDocument.documentAccreditationSection
            this.identifier = 'pnpDocument'
            // insert standards to first standard select box
            $ngRedux.dispatch({
                type: PNP_SELECT_CASCADE_STANDARD,
                id: this.identifier,
                level: 0,
                standards: this.sectionsTree,
                standardId: null,
                standardParentId: null,
            });

            let selectedLevel1Id, selectedLevel2Id, selectedLevel3Id;
            if (this.standardId && this.standardParentId) {
                const standard2 = this.findChildStandardById(this.standardParentId, this.sectionsTree);
                selectedLevel1Id = standard2.standardParentId;
                selectedLevel2Id = this.standardParentId;
                selectedLevel3Id = this.standardId;
            }
            else {
                selectedLevel1Id = get(this.sectionsTree, '[0].id');
                selectedLevel2Id = get(this.sectionsTree, '[0].children[0].id');
                selectedLevel3Id = get(this.sectionsTree, '[0].children[0].children[0].id');
            }

            if (selectedLevel1Id) this.onSelectStandard({ item: { value: selectedLevel1Id }, skipGridFetch: true, deselectAll });
            if (selectedLevel2Id) this.onSelectStandard({ item: { value: selectedLevel2Id }, skipGridFetch: true, deselectAll });
            let level3Standard;
            if (selectedLevel3Id)
                level3Standard = this.onSelectStandard({ item: { value: selectedLevel3Id }, skipGridFetch: !!deselectAll, deselectAll });

            if (level3Standard && deselectAll === false) {
                this.getFrameworkRequirementDetails({
                    ...level3Standard,
                    schemeCode: this.schemeCode
                });
            }
            if (deselectAll)
                $ngRedux.dispatch({
                    type: PNP_SELECT_CASCADE_STANDARD_RESET,
                    id: this.identifier,
                });
        }

        this.findChildStandardById = (id, standards) => {
            return standards.reduce((result, item) => {
                if (result)
                    return result;
                if (item.id === id)
                    return item
                else if (item.children.length)
                    return this.findChildStandardById(id, item.children)
            }, null);
        }




        this.onSelectStandard = ({ item, skipGridFetch = undefined, deselectAll = false }) => {
            const standard = this.findChildStandardById(item.value, this.sectionsTree);
            const level3Standards = standard.level === 1 && standard.children.length
                ? this.findChildStandardById(standard.children[0].id, this.sectionsTree).children
                : undefined;
            $ngRedux.dispatch({
                type: PNP_SELECT_CASCADE_STANDARD,
                id: this.identifier,
                standardId: standard.id,
                level: standard.level,
                standards: standard.children,
                level3Standards,
                schemeCode: this.pnpDocument.selectdocumentAccreditationSchemes
            });

            const level3Standard =
                level3Standards?.length && level3Standards[0]
                || standard.children?.length && standard.children[0]
                || standard;

            if (deselectAll === false) {
                this.selectedSection = level3Standard
            }
            return level3Standard
        }

        this.onButtonAssignReqDocToSection = () => {
            if (!this.selectedSection) {
                Notifier.error('No section selected. Please select a section to proceed.');
                return;
            }

            if (!this.addedItems) {
                this.addedItems = [];
            }

            // Retrieve the current Redux state for `pnpDocSectionsGrid`
            const currentState = $ngRedux.getState();
            const gridItems = currentState?.policies?.pnpDocSectionsGrid?.items || [];
            // Check if the item already exists in the Redux state
            const isAlreadyInGrid = gridItems.some((gridItem) => gridItem.id === this.selectedSection.id);

            if (isAlreadyInGrid) {
                Notifier.error('The Applicable Sections Grid already exists in the grid.');
                return;
            }

            const data = {
                accreditationId: this.selectedSection.accreditationId,
                description: this.selectedSection.description,
                id: this.selectedSection.id,
                level: this.selectedSection.level,
                name: this.selectedSection.name,
            };
            this.addedItems.push(data);
            const itemsForGrid = this.addedItems.map((addedItem) => ({
                id: addedItem.id,
                name: addedItem.name,
            }));
            Notifier.success('Applicable Sections Grid added successfully.');

            $ngRedux.dispatch({
                type: 'GRID_FETCH',
                id: 'pnpDocSectionsGrid',
                items: itemsForGrid,
            });

        };



        this.onButtonDetachReqDocFromSection = ({ item }) => {
            // Get the current Redux state for pnpDocSectionsGrid
            const currentState = $ngRedux.getState();
            const gridItems = currentState?.policies?.pnpDocSectionsGrid?.items || [];

            const updatedGridItems = gridItems.filter((gridItem) => gridItem.id !== item.id);

            $ngRedux.dispatch({
                type: 'GRID_FETCH',
                id: 'pnpDocSectionsGrid',
                items: updatedGridItems,
            });

            if (this.addedItems) {
                this.addedItems = this.addedItems.filter((addedItem) => addedItem.id !== item.id);
            }

        }

        this.saveDetails = () => {
            $scope.$broadcast('show-errors-check-validity', '$ctrl.pnpAccrediationDocumentForm');
            // Retrieve the current Redux state for `pnpDocSectionsGrid`
            const currentState = $ngRedux.getState();
            const gridItems = currentState?.policies?.pnpDocSectionsGrid?.items || [];
            const data = {
                id: $state.params.id,
                accreditationSection: gridItems
            }
            if (this.pnpAccrediationDocumentForm.$valid) {
                this.saveAccreditationDocument(data).then(() => {
                    Notifier.success('Accreditation document has been saved successfully.');
                    this.resetForm();
                }).catch(() => {
                    Notifier.error('System Error!');
                });
            } else {
                Notifier.error('Please fill in the form fields');
            }
        }


        this.resetForm = () => {
            this.pnpAccrediationDocumentForm.$setPristine();
            this.pnpAccrediationDocumentForm.$setUntouched();
            $ngRedux.dispatch({
                type: PNP_SELECT_CASCADE_STANDARD_RESET,
                id: 'pnpDocument',
            });
            $ngRedux.dispatch({
                type: 'GRID_FETCH',
                id: 'pnpDocSectionsGrid',
                items: [],
            });
            this.addedItems = [];
            this.pnpDocument.selectdocumentAccreditationSchemes = null;
        };

        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            unsubscribe();
            unsubscribeAccrediationSectionChange()
            unsubscribeselectChangePnpDocument()
        }
    },
    template: require('./pnp-doc-accreditation-details.html')
}
